export default "__VITE_ASSET__DTsJE_Jb__"